import { render, staticRenderFns } from "./HistogramSliderW2.vue?vue&type=template&id=6a8fcf82&"
import script from "./HistogramSliderW2.vue?vue&type=script&lang=js&"
export * from "./HistogramSliderW2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports